export default "<router-outlet>\n\n\n</router-outlet>\n\n\n<toaster-container [toasterconfig]=\"config\"></toaster-container>\n"